import { render, staticRenderFns } from "./banks.vue?vue&type=template&id=d9624d32"
import script from "./banks.vue?vue&type=script&lang=js"
export * from "./banks.vue?vue&type=script&lang=js"
import style0 from "./banks.vue?vue&type=style&index=0&id=d9624d32&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports